import {
  FetchPayrollHistory,
  filePresign,
  linkFormToProject,
  linkTaskToForm,
  unlinkFormToProject,
  updateForm,
} from "../actions/action";
import {
  ADD_CREDIT_NOTE,
  CREATE_UNLINK,
  DELETE_Contacts,
  FETCH_TODAYONBOARDDETAILS,
  FETCH_USER_NOTIFICATION,
  LAST_365_INVOICE_INSIGHTS,
  OCR_DOCUMENT_ACCEPT,
  OCR_DOCUMENT_BY_ID,
  OCR_DOCUMENT_DELETE,
  OCR_DOCUMENT_DUPLICATE,
  OCR_DOCUMENT_SAVED,
  OCR_FETCH_ALL_DOCUMENTS,
  OCR_PROCESSED_DOCUMENT,
  PROJECT_COST_DETAILS,
  DEQUEUE_PURCHASE_ORDER_EMAIL_JOB,
  RESET_PURCHASE_ORDER_EMAIL_JOB,
  SET_PURCHASE_ORDER_EMAIL_JOB,
  DEQUEUE_RENT_ORDER_EMAIL_JOB,
  RESET_RENT_ORDER_EMAIL_JOB,
  SET_RENT_ORDER_EMAIL_JOB,
  UPDATE_ASSETS,
  UPDATE_SYNC_QB_STATUS,
  START_PURCHASE_ORDER_EMAIL_JOB,
  START_RENT_ORDER_EMAIL_JOB,
} from "../constants/type";

const purchaseOrderEmailJobInitialState = {
  status: "idle",
  requestId: "",
  orderId: "",
  orderCode: "",
  supplierEmail: "",
  toggleActive: false,
  templateId: "",
  templateData: null,
  pdfLink: "",
  error: "",
};

const purchaseOrderEmailJobQueueInitialState = [];

const rentOrderEmailJobInitialState = {
  status: "idle",
  requestId: "",
  orderId: "",
  orderCode: "",
  supplierEmail: "",
  toggleActive: false,
  templateId: "",
  templateData: null,
  pdfLink: "",
  error: "",
};

const rentOrderEmailJobQueueInitialState = [];

const initialState = {
  FetchCompanyDetails: {
    status: true,
    message: "Fetched Successfully",
    data: [
      {
        companyid: "28830f30-b321-4662-a576-f23451677734",
        companyname: "Spire Essentials",
        companylogo:
          "https://spire-solutions-dev.s3.ap-south-1.amazonaws.com/Group 3219@2x.png",
        logowithtitle:
          "https://spire-solutions-dev.s3.ap-south-1.amazonaws.com/SpireEssentials Logo@2x.png",
        backgroundcolor: "#FFFFFF",
        backgroundimage:
          "https://spire-solutions-dev.s3.ap-south-1.amazonaws.com/blanco briefpapier (1)_page-0001.jpg",
        primarycolor: "#00246A",
        secondarycolor: "#FFFFFF",
        textcolor: "#333333",
        label: "#707070",
        ispaymentexpired: 0,
        domain: "https://essentials-dev.spire.solutions",
        billingInformationid: "cbea0b5e-202e-4355-949a-f12720dca294",
      },
    ],
  },
  signupData: {},
  loginData: null,
  fetchMyFacebook: {},
  forgotPassword: {},
  forgotPassEmail: {},
  userlogout: {},
  EmailExistOrNot: {},
  userCreate: {},
  userUpdate: {},
  fetchDocument: {},
  AddDocument: {},
  AddDocToUserContacts: {},
  AddDocToClientsdata: {},
  UploadToS3: {},
  deleteDoc: {},
  FetchUsersByCompany: {},
  FetchUsersSchedule: {},
  AddUserLogTimer: {},
  UpdateUserTimeOff: {},
  AddTagsContact: {},
  FetchContactsByCompanyid: {},
  FetchAddTagsContactdata: {},
  FetchCompanyList: {},
  FetchlanguagesList: {},
  FetchTranslationList: {},
  FetchCreatetranslist: {},
  updateTranslationDataList: {},
  FetchScreenList: {},
  FetchManagersList: {},
  FetchContactByIddata: {},
  FetchSearchClientsdata: {},
  FetchSearchSupplierdata: {},
  FetchDocsContactByIdData: {},
  FetchLinkClientByIdData: [],
  FetchLinkClientByIddata: [],
  FetchContactsByClientIddata: {},
  DeleteTags: {},
  DeleteDocsdata: {},
  AddContacts: {},
  AddCompanys: {},
  UpdateCompanyContactdata: {},
  UpdateContactsdata: {},
  FetchJobtypes: {},
  DeleteJobtypes: {},
  DeleteContactsdata: {},
  CreateUnlinkContactdata: {},
  AddJobtypes: {},
  UpdateJobtypes: {},
  updateTaskResponse: {},
  deleteChecklistResponse: {},
  addComments: {},
  addTaskResponse: {},
  fetchTaskResponse: {},
  addChecklistResponse: {},
  fetchCompanyProjectData: {},
  fetchUsersByCompany: {},
  fetchLinkClients: {},
  fetchTasksResponse: {},
  fetchContactTaskResponse: {},
  deleteTaskResponse: {},
  updateTaskStatusResponse: {},
  activeStatusResponse: {},
  fetchTeamsListResponse: {},
  fetchEquipmentListResponse: {},
  fetchAssigneeResponse: {},
  userNotifications: [],
  taskForAWeekResponse: {},
  updateCalendarDataResponse: {},
  taskGrouping: {},
  projectGrouping: {},
  fetchWeekly: {},
  fetchProjectWeekly: {},
  FetchRoleModuleAccess: {},
  fetchProject: {},
  fetchProjectBB: {},
  fetchClient: {},
  fetchActiveUser: {},
  fetchProjectById: {},
  updateProjectById: {},
  addDocumentProject: {},
  fetchAssetTree: {},
  fetchDocumentProject: {},
  addAssetPurchasingOrder: {},
  deletePo: {},
  changePoStatus: {},
  taskToday: {},
  changeStatus: {},
  allScreenTrnslations: {},
  fetchSuppliers: {},
  fetchProjects: {},
  fetchProductBySupplierId: {},
  addPurchasingOrder: {},
  sendEmailPurchasingOrder: {},
  purchaseOrderEmailJob: { ...purchaseOrderEmailJobInitialState },
  purchaseOrderEmailJobQueue: [...purchaseOrderEmailJobQueueInitialState],
  rentOrderEmailJob: { ...rentOrderEmailJobInitialState },
  rentOrderEmailJobQueue: [...rentOrderEmailJobQueueInitialState],
  fetchPoOrderCode: {},
  fetchWarehousePurchasingOrder: [],
  fetchPurchasingOrder: {},
  fetchsupplierlist: {},
  AddDocToSupplierData: {},
  FetchDocsSupplierByIdData: {},
  FetchSupplierListDATA: {},
  FetchSupplierById: {},
  addToWarehouse: {},
  addItemInExistingOrder: {},
  updateOrderProductQty: {},
  // FetchSupplierListDATA:{},
  // FetchSupplierById:{},
  AddSupplier: {},
  UpdateSupplierdata: {},
  DeleteDocSupplier: {},

  fetchProductionHistory: {},
  fetchProductList: {},
  deleteProductList: {},
  fetchSuppliersProduct: {},
  fetchLastPurchasingOrderCode: {},
  fetchEquipmentAndPart: {},
  fetchProductPart: [],
  addProductPart: {},
  updateProductPart: {},
  productPartCodeEmailExistOrNot: {},
  selectedColor: "",
  recentColors: [],
  selectedStockColor: "",
  recentStockColors: [],
  appSideNavOptions: [],
  totalStockAvailable: [],
  advicedItemPurchase: [],
  fetchPurchasingOrderAwaiting: [],
  fetchNotEnrolledPayroll: [],
  fetchDocumentByProductPartId: {},
  fetchDocumentByAssetsId: {},
  fetchPOByProjectResponse: {},
  fetchQuotesResponse: {},
  fetchInvoicesResponse: {},
  addInvoicesResponse: {},
  fetchTaskByProjectResponse: {},
  FetchlastQuotecodeResponse: {},
  CreateDuplicateQuotesResponse: {},
  DeativatedQuoteResponse: {},
  bookkeeping_props: {},
  CheckIfTimeSessionStartOrNotResponse: {},
  CreateNewTimeSessionResponse: {},
  GetTimeSessionResponse: {},
  UpdateTimeSessionResponse: {},
  fetchAddProjectId: {},
  GetActiveTimeSessionOnPlanboardResponse: {},
  StopTimerFromHeaderResponse: {},
  OpenTimerFromHeaderResponse: {},
  projectTab: "General",
  fetchInvoiceByIdResponse: {},
  updateInvoiceResponse: {},
  addUpdateFinancialByProjectResponse: {},
  FetchFinancialByProjectResponse: {},
  updateProjectCover: {},
  fetchProjectKanBan: {},
  FetchQuotesByCompanyidResponse: {},
  AddQuotesResponse: {},
  ApproveQuotesResponse: {},
  addSectionResponse: {},
  getQuoteSectionsResponse: {},
  duplicateSectionResponse: {},
  deleteSectionResponse: {},
  updateQuoteSectionsResponse: {},
  addSubSectionResponse: {},
  deleteSubSectionResponse: {},
  activateQuoteResponse: {},
  FetchTeamProjectWiseResponse: {},
  FetchTeamsResponse: {},
  UpdatePOTaskStatusResponse: {},
  AddTaskToTeamResponse: {},
  PoList: {},
  approvePO: {},
  fetchInvoioceAllList: {},
  fetchProductPartList: {},
  addInvoiceProject: {},
  updateInvoiceProjectRes: {},
  fetchPaymentDeadline: {},
  fetchInvoiceByInvoiceID: {},
  fetchProjectByClientRes: {},
  fetchProductsByQuotesRes: {},
  invoiceDeleteRes: {},
  fetchLastInvoiceCodeRes: {},
  FetchInvoiceSettingListResponse: {},
  fetchInvoiceSettingById: {},
  addInvoiceSetting: {},
  fetchMembers: {},
  fetchTeamMembers: {},
  addTeamList: {},
  fetchPartsList: {},
  deleteTeam: {},
  fetchTeam: {},
  updateTeam: {},
  deleteTeamMember: {},
  fetchOrderPickingListRes: {},
  addOrderPickingRes: {},
  fetchStockListRes: {},
  addCountStockRes: {},
  fetchCountStockReportRes: {},
  deleteCountStockReportRes: {},
  updateCountStock: {},
  updateCheckCountStock: {},
  quoteExtraWorkValidation: {},
  fetchEquipmentByWeekRes: {},
  addEquipmentToTaskRes: {},
  fetchProvisionalRes: {},
  updateSupplierContactPosition: {},
  addCreditNote: {},
  assetList: {},
  addAssets: {},
  fetchPurchasingAssetList: {},
  assetTypes: [],
  deleteAsset: {},
  fetchParticularAsset: {},
  groupList: [],
  selectedParts: [],
  deleteGroup: [],
  addGroup: [],
  equipemtPartList: [],
  equipmentList: [],
  clientList: [],
  categoryList: [],
  facilityList: [],
  assetsListNew: [],
  assetsTypeList: [],
  dashboardWidgets: [],
  showWorkersActivity: [],
  showTopProjects: [],
  onboardDetails: {},
  fetch365Inventory: [],
  projectsByWeek: {},
  weeklyProjectCount: {},
  assetsInstructionsList: {},
  turnUnacailableRes: {},
  last365InvoiceInsights: {},
  modalRes: {},
  productAndPartValidationRes: {},
  getStageListRes: {},
  addStageRes: {},
  updateStageRes: {},
  deleteStageRes: {},
  changeStageNameRes: {},
  getTaskStatusListRes: {},
  getSectionsListRes: {},
  createSectionRes: {},
  invoiceSendEmailRes: {},
  invoiceSendEmailCountRes: {},
  showAdvancedTaskSystem: true,
  GetProjectStatusDropdownListRes: {},
  getTaskByStatusRes: {},
  updateSectionNameRes: {},
  deleteSectionRes: {},
  fetchLastCreditInvoiceCodeRes: {},
  invoiceGenratePDFRes: {},
  fetchTaskWithoutProjectRes: {},
  fetchOrderPickingProductDropdown: {},
  addReturnToWarehouseRes: {},
  updateWareHouseProjectRes: {},
  fetchProductPartCategoriesRes: {},
  assetUpdateRes: {},
  fetchAssetPurchasingOrderByIdRes: {},
  fetchProductFilterListRes: {},
  sendInvoiceEmailRes: {},
  sendInvoiceEmailCountRes: {},
  isFileUploading: false,
  userVerificationRes: {},
  qbSyncStatus: "",
  qbSyncResponse: {},
  projectCostDetails: {},
  taskModalCommentDeleteRes: {},
  addBillingInformationRes: {},
  updateBillingInformationRes: {},
  fetchBillingInformationRes: {},
  fetchIndustryRes: {},
  addIndustryToCompanyRes: {},
  sendApprovedQuotesEmailRes: {},
  ocrProcessedDocument: {},
  ocrDocumentSaved: false,
  ocrAllDocuments: [],
  ocrDocumentById: {},
  poSupplierNmaeIDRes: {},
  fetchClientsByCompanyRes: {},

  // Form builder
  formList: {},
  workflowFormList: {},
  formById: {},
  templateForms: {},
  updateForm: {},
  deleteForm: null,
  addPersonalTaskRes: {},
  fetchPersonalTaskRes: {},
  ocrDocumentAccept: {},
  ocrDocumentDuplicate: {},
  ocrDocumentDelete: {},
  fetchIntergrationRes: {},
  updateIsCheckPersonalTaskRes: {},
  azureTokenUpdateRes: {},
  templateTypes: {},
  availableFields: {},
  availableTemplates: {},
  formsByProject: null,
  linkFormToProject: null,
  unlinkFormToProject: null,
  linkTaskToForm: null,
  fetchUserMaxAmountRes: {},
  updateUserMaxAmountRes: {},
  approvedOrderRes: {},
  workflowList: {},
  workflowTriggerList: {},
  workflowRulesList: {},
  workflowTaskStatusList: {},
  workflowTaskList: {},
  workflowActions: {},
  workflowTaskType: {},
  workflowQuestions: {},
  workflowData: {},
  fetchBillingTermsRes: {},
  addNewClientRes: {},
  updateClientDetailsRes: {},
  fetchClientByIdRes: {},
  existingCompanyAddressRes: {},
  deleteMultipleAdressRes: {},
  fetchClientContactsByClientIdRes: {},
  fetchClientTasksRes: {},
  clientActivityTimelineRes: {},
  getCreditTypeDropDownRes: {},
  getInvoiceTypeDropDownRes: {},
  getDiscountTypeDropDownRes: {},
  addDiscountRes: {},
  dleteClientContactRes: {},
  idsType: null,
  employeeType: null,
  contractType: null,
  companyCar: null,
  fetchedReasons: null,
  fetchedCertification: null,
  insertedDoc: null,
  quoteProducts: {},
  emailRes: null,
  formResponse: null,
  quoteGenratePDFResponse: {},
  fetchProjectWorksRes: {},
  deleteWorkListRes: {},
  addWorkTaskRes: {},
  deletWorkTaskRes: {},
  fetchWorkTaskByIdRes: {},
  updateWorkTaskRes: {},
  projectHireListRes: {},
  projectHireCreateRes: {},
  projectHireUpdateRes: {},
  projectHireDeleteRes: {},
  UpdateProjectHiringStatusRes: {},
  UpdateProjectHiringExtendPeriodRes: {},
  projectRentDeleteRes: {},
  UpdateProjectRentStatusRes: {},
  UpdateProjectRentExtendPeriodRes: {},
  addPhaseMaterialsRes: {},
  fetchPhaseMaterialsByProjectRes: {},
  fetchPhaseMaterialsByIdRes: {},
  deletePhaseRes: {},
  deleteMaterialsRes: {},
  addMaterialListRes: {},
  fetchMaterialListRes: {},
  updateMaterialQuantityRes: {},
  updateTaskImageRes: {},
  fetchUserTitleRes: {},
  addUpdateUserTitleRes: {},
  deleteUserTitleRes: {},
  fetchProjectsByWeeksRes: {},
  singleUploadToS3Res: {},
  multipleUploadToS3Res: {},
  downloadDocumentRes: {},
  storeTimerScreenShotsRes: {},
  timeManagementSessionTimeLineRes: {},
  deleteScreenShotsRes: {},
  timeManagementDailySummaryRes: {},
  addTranslationDataRes: {},
  addNewBillingRes: {},
  deleteNewBillingRes: {},
  deleteUserTimeOffRes: {},
  fecthUnitsProductsRes: {},
  AddTypeOfEmployeeRes: {},
  AddTypeOfIDRes: {},
  AddContractTypeRes: {},
  AddBenifitCompanyCarRes: {},
  AddBenifitReasonsRes: {},
  makeTemplateDefaultRes: {},
  fetchDefaultTemplateRes: {},
  filesInsertDocToS3Res: {},
  addDocumentToTaskRes: {},
  addTaskFormRes: {},
  updateTaskFormRes: {},
  deleteTaskFormRes: {},
  fetchTaskFormRes: {},
  deleteBOMitemRes: {},
  deleteSubSectionPartsRes: {},
  driveAddFolderRes: {},
  zeroParentsFolderRes: {},
  fetchSpireFolderDocumentsRes: {},
  deleteDriveFolderORFileRes: {},
  addDocRootRes: {},
  driveUpdateFolderRes: {},
  fileChunkStartRes: {},
  filePresignRes: {},
  fileChunkCompleteRes: {},
  fileChunkAbortRes: {},
  fetchFormCertificateRes: {},
  ajitSpireJsonApiRes: {},
  coWorkerCertificationsApiRes: {},
  fetchToDoListApiRes: {},
  updateTaskAssigneeApiRes: {},
  updateTaskPriorityApiRes: {},
  updateTaskIndexApiRes: {},
  updateChecklistDataRes: {},
  deleteProjectRes: {},
  addTaskDescriptionRes: {},
  fetchBrandHealthApplicationRes: {},
  supplierEmailExistOrNotRes: {},
  clientNameExistOrNotRes: {},
  removeTaskAssigneeRes: {},
  assigneeLocalDataRes: {},
  productCatalogueApiRes: {},
  fetchAutoProductPartItemIDRes: {},
  duplicateTemplateRes: {},
  fetchTodoListByProjectRes: {},
  addDocumentToOrderRes: {},
  fetchDocumentByOrderIDRes: {},
  fetchProductsWithoutSupplierRes: {},
  addSupplierToProductsRes: {},
  supplierCodeExistOrNotRes: {},
  supplierBarCodeRes: {},
  supplierBarCodeScanRes: {},
  sendEmailToSupplierRes: {},
  partDuplicateRes: {},
  updateProductDescriptionRes: {},
  addTaskActivityRes: {},
  updateTaskActivityRes: {},
  searchActivityRes: {},
  fetchActivityRes: {},
  deleteActivityRes: {},
  timerActivityRes: {},
  getTimerActivityRes: {},
  fetchProjectEquipmentActivityRes: {},
  searchAiFolderFileRes: {},
  updateUserFilterRes: {},
  addPartsEquipmentsRes: {},
  fetchPartsEquipmentsRes: {},
  updatePartsEquipmentsRes: {},
  deletePartsEquipmentsRes: {},
  updateTaskEstimationsRes: {},
  buildPOdataRes: {},
  deleteResourcePoRes: {},
  logoutSessionRes: {},
  fetchTaskHistoryRes: {},
  fetchTaskTimesheetRes: {},
  addUpdateTaskDependenciesRes: {},
  deleteDependenciesRes: {},
  addTaskProductPartsRes: {},
  updateTaskProductPartsRes: {},
  fetchTaskProductPartsRes: {},
  deleteTaskProductPartsRes: {},
  fetchTaskCostDetailsRes: {},
  createTaskInvoiceRes: {},
  updateSectionDefaultRes: {},
  deleteComposeProductRes: {},
  updatePoductPartQtyRes: {},
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "USER_LOGIN":
      return {
        ...state,
        loginData: action.data,
      };
    case "FETCH_MYFACEBOOK":
      return {
        ...state,
        fetchMyFacebook: action.data,
      };
    case "SEND_EMAIL":
      return {
        ...state,
        forgotPassEmail: action.data,
      };
    case "FORGOT_PASS":
      return {
        ...state,
        forgotPassword: action.data,
      };
    case "SUB_DOMAIN_NAME":
      return {
        ...state,
        FetchCompanyDetails: action.data,
      };
    case "FETCH_ROLE_MODULE":
      return {
        ...state,
        roleModuleData: action.data,
      };
    case "FETCH_USER_BY_ID":
      return {
        ...state,
        FetchUserById: action.data,
      };
    case "USER_LOGOUT":
      return {
        ...state,
        userlogout: action.data,
      };
    case "EMAIL_EXIST_OR_NOT":
      return {
        ...state,
        EmailExistOrNot: action.data,
      };
    case "USER_CREATE":
      return {
        ...state,
        userCreate: action.data,
      };
    case "USER_UPDATE":
      return {
        ...state,
        userUpdate: action.data,
      };
    case "CLEAR_USER_UPDATE":
      return {
        ...state,
        userUpdate: {},
      };
    case "FETCH_DOCUMENT_BY_ID":
      return {
        ...state,
        fetchDocument: action.data,
      };
    case "ADD_DOC_TO_USER":
      return {
        ...state,
        AddDocument: action.data,
      };
    case "ADD_DOC_TO_CONTACT":
      return {
        ...state,
        AddDocToUserContacts: action.data,
      };
    case "FETCH_DOCSUPPLIER_BYID":
      return {
        ...state,
        FetchDocsSupplierByIdData: action.data,
      };

    // FetchDocsSupplierByIdData
    case "ADD_DOC_TO_SUPPLIER":
      return {
        ...state,
        AddDocToSupplierData: action.data,
      };

    case " ADD_DOC_TO_CLIENT":
      return {
        ...state,
        AddDocToClientsdata: action.data,
      };
    case "UPLOAD_TO":
      return {
        ...state,
        UploadToS3: action.data,
      };
    case "DELETE_DOCUMENET":
      return {
        ...state,
        deleteDoc: action.data,
      };
    case "FATCH_USER_BY_COMPANY_ID":
      return {
        ...state,
        FetchUsersByCompany: action.data,
      };
    case "FETCH_USER_SCHEDULE":
      return {
        ...state,
        FetchUsersSchedule: action.data,
      };
    case "UPDATE_USER_LOG_TIMER":
      return {
        ...state,
        AddUserLogTimer: action.data,
      };
    case "UPDATE_USER_TIME_OFF":
      return {
        ...state,
        UpdateUserTimeOff: action.data,
      };
    case "FATCH_CONTACT_ID":
      return {
        ...state,
        FetchContactsByCompanyid: action.data,
      };
    case "FETCH_SUPPLIER_BYID":
      return {
        ...state,
        FetchSupplierById: action.data,
      };
    case "ADD_TAGS_CONTACT":
      return {
        ...state,
        AddTagsContact: action.data,
      };
    case "FETCH_TAGS_CONTACT":
      return {
        ...state,
        FetchAddTagsContactdata: action.data,
      };
    case "FETCH_COMPANY":
      return {
        ...state,
        FetchCompanyList: action.data,
      };
    case "FETCH_LANGUAGES":
      return {
        ...state,
        FetchlanguagesList: action.data,
      };
    case "FETCH_TRANSLATION":
      return {
        ...state,
        FetchTranslationList: action.data,
      };
    case "FETCH_CREATETRANSLATION":
      return {
        ...state,
        FetchCreatetranslist: action.data,
      };
    case "UPDATE_TRANSLATION_DATA":
      return {
        ...state,
        updateTranslationDataList: action.data,
      };
    case "FETCH_SCREEN":
      return {
        ...state,
        FetchScreenList: action.data,
      };
    case "FETCH_MANAGERS_LIST":
      return {
        ...state,
        FetchManagersList: action.data,
      };
    case "FETCH_CONTACT_BYID":
      return {
        ...state,
        FetchContactByIddata: action.data,
      };
    case "FETCH_SEARCH_CLIENTS":
      return {
        ...state,
        FetchSearchClientsdata: action.data,
      };
    case "FETCH_SEARCH_SUPPLIER":
      return {
        ...state,
        FetchSearchSupplierdata: action.data,
      };

    case "FETCH_DOCSCONTACT_BYID":
      return {
        ...state,
        FetchDocsContactByIdData: action.data,
      };
    case "FETCH_DOCSCLIENT_BYID":
      return {
        ...state,
        FetchLinkClientByIdData: action.data,
      };
    case "REMOVE_DOCSCLIENT_BYID":
      return {
        ...state,
        FetchLinkClientByIddata: action.data,
        FetchLinkClientByIdData: action.data,
      };
    case "FETCH_LINKCLIENT_BYID":
      return {
        ...state,
        FetchLinkClientByIddata: action.data,
      };
    case "FETCH_CONTACTSCLIENT_BYID":
      return {
        ...state,
        FetchContactsByClientIddata: action.data,
      };
    case " DELETE_TAGS":
      return {
        ...state,
        DeleteTags: action.data,
      };
    case "DELETE_DOCS":
      return {
        ...state,
        DeleteDocsdata: action.data,
      };

    case "ADD_CONTACTS":
      if (
        state.FetchContactsByCompanyid &&
        state.FetchContactsByCompanyid.data &&
        action.data.data
      )
        state.FetchContactsByCompanyid.data.data.unshift(action.data.data.data);
      return {
        ...state,
        AddContacts: action.data,
      };
    case "ADD_SUPPLIER":
      return {
        ...state,
        AddSupplier: action.data,
      };

    case "ADD_COMPANY":
      return {
        ...state,
        AddCompanys: action.data,
      };
    case "UPDATE_COMPANY":
      return {
        ...state,
        UpdateCompanyContactdata: action.data,
      };
    case "UPDATE_CONTACTS":
      return {
        ...state,
        UpdateContactsdata: action.data,
      };
    case "UPDATE_SUPPLIER":
      return {
        ...state,
        UpdateSupplierdata: action.data,
      };

    case "FETCH_JOB_TYPES":
      return {
        ...state,
        FetchJobtypes: action.data,
      };
    case "DELETE_JOB_TYPES":
      return {
        ...state,
        DeleteJobtypes: action.data,
      };
    case DELETE_Contacts:
      return {
        ...state,
        DeleteContactsdata: action.data,
      };
    case CREATE_UNLINK:
      return {
        ...state,
        CreateUnlinkContactdata: action.data,
      };
    case "ADD_JOB_TPYE":
      return {
        ...state,
        AddJobtypes: action.data,
      };
    case "UPDATE_JOB_TPYE":
      return {
        ...state,
        UpdateJobtypes: action.data,
      };
    case "UPDATE_TASK":
      return {
        ...state,
        updateTaskResponse: action.data,
      };
    case "DELETE_CHECKLIST":
      return {
        ...state,
        deleteChecklistResponse: action.data,
      };
    case "ADD_COMM":
      return {
        ...state,
        addComments: action.data,
      };
    case "ADD_TASK":
      return {
        ...state,
        addTaskResponse: action.data,
      };
    case "FETCH_TASK_BY_ID":
      return {
        ...state,
        fetchTaskResponse: action.data,
      };
    case "ADD_CHECKLIST":
      return {
        ...state,
        addChecklistResponse: action.data,
      };
    case "FETCH_PROJECT_BY_COMPANY":
      return {
        ...state,
        fetchCompanyProjectData: action.data,
      };
    case "FETCH_USER_BY_COMPANY":
      return {
        ...state,
        fetchUsersByCompany: action.data,
      };
    case "FETCH_LINK":
      return {
        ...state,
        fetchLinkClients: action.data,
      };
    case "FETCH_TASKS_BY_COMPANY_ID":
      return {
        ...state,
        fetchTasksResponse: action.data,
      };
    case "FETCH_TASK_BY_CONTACT_ID":
      return {
        ...state,
        fetchContactTaskResponse: action.data,
      };
    case FETCH_USER_NOTIFICATION:
      return {
        ...state,
        userNotifications: Array.isArray(action.data)
          ? action.data
          : Array.isArray(action.data?.data)
            ? action.data.data
            : Array.isArray(action.data?.items)
              ? action.data.items
              : Array.isArray(action.data?.notifications)
                ? action.data.notifications
                : [],
      };

    case "IS_CURRENTCOMPANY":
      return {
        ...state,
        forswitchCompany: action.data,
      };

    case "DELETE_TASK":
      return {
        ...state,
        deleteTaskResponse: action.data,
      };
    case "UPDATE_TASK_STATUS":
      return {
        ...state,
        updateTaskStatusResponse: action.data,
      };
    case "ACTIVE_STATUS":
      return {
        ...state,
        activeStatusResponse: action.data,
      };

    case "TASK_FOR_A_WEEK":
      return {
        ...state,
        taskForAWeekResponse: action.data,
      };
    case "UPDATE_CALENDAR_DATA":
      return {
        ...state,
        updateCalendarDataResponse: action.data,
      };

    case "TASK_GROUPING":
      return {
        ...state,
        taskGrouping: action.data,
      };

    case "FETCH_WEEKLY":
      return {
        ...state,
        fetchWeekly: action.data,
      };
    case "FATCH_ROLEMODULE_ACCESS":
      return {
        ...state,
        FetchRoleModuleAccess: action.data,
      };

    case "FETCH_PROJECT":
      return {
        ...state,
        fetchProject: action.data,
      };
    case "FETCH_PROJECT_BB":
      return {
        ...state,
        fetchProjectBB: action.data,
      };

    case "CREATE_PROJECT":
      return {
        ...state,
        createProject: action.data,
      };

    case "FETCH_CLIENT":
      return {
        ...state,
        fetchClient: action.data,
      };

    case "FETCH_ACTIVE_USER":
      return {
        ...state,
        fetchActiveUser: action.data,
      };

    case "FETCH_PROJECT_BY_ID":
      return {
        ...state,
        fetchProjectById: action.data,
      };

    case "UPDATE_PROJECT_BY_ID":
      return {
        ...state,
        updateProjectById: action.data,
      };

    case "ADD_DOCUMENT_PROJECT":
      return {
        ...state,
        addDocumentProject: action.data,
      };

    case "FETCH_ASSET_TREE_LIST":
      return {
        ...state,
        fetchAssetTree: action.data,
      };
    case "FETCH_DOCUMENT_PROJECT":
      return {
        ...state,
        fetchDocumentProject: action.data,
      };
    case "ADD_ASSET_PURCHASING_ORDER":
      return {
        ...state,
        addAssetPurchasingOrder: action.data,
      };

    case "TASK_TODAY":
      return {
        ...state,
        taskToday: action.data,
      };

    case "CHANGE_STATUS":
      return {
        ...state,
        changeStatus: action.data,
      };

    case "SET_ALLSCREEN_TRANSLATION":
      return {
        ...state,
        allScreenTrnslations: {
          ...state.allScreenTrnslations,
          [action.data.screenName]: action.data.translations,
        },
      };

    case "FETCH_SUPPLIERS_LIST":
      return {
        ...state,
        FetchSupplierListDATA: action.data,
      };

    case "FETCH_PROJECTS":
      return {
        ...state,
        fetchProjects: action.data,
      };
    case "FETCH_TASK_BY_PROJECT":
      return {
        ...state,
        fetchProjectTasks: action.data,
        fetchTaskByProjectResponse: action.data,
      };
    case "FETCH_PRODUCT_BY_SUPPLIER_ID":
      return {
        ...state,
        fetchProductBySupplierId: action.data,
      };

    case "ADD_PURCHASING_ORDER":
      return {
        ...state,
        addPurchasingOrder: action.data,
      };

    case "SEND_EMAIL_FOR_PURCHASING_ORDER":
      return {
        ...state,
        sendEmailPurchasingOrder: action.data,
      };

    case START_PURCHASE_ORDER_EMAIL_JOB:
      return {
        ...state,
        purchaseOrderEmailJobQueue: [
          ...state.purchaseOrderEmailJobQueue,
          {
            ...action.data,
          },
        ],
      };

    case DEQUEUE_PURCHASE_ORDER_EMAIL_JOB:
      return {
        ...state,
        purchaseOrderEmailJobQueue: state.purchaseOrderEmailJobQueue.slice(1),
      };

    case SET_PURCHASE_ORDER_EMAIL_JOB:
      return {
        ...state,
        purchaseOrderEmailJob: {
          ...state.purchaseOrderEmailJob,
          ...action.data,
        },
      };

    case RESET_PURCHASE_ORDER_EMAIL_JOB:
      return {
        ...state,
        purchaseOrderEmailJob: { ...purchaseOrderEmailJobInitialState },
      };

    case START_RENT_ORDER_EMAIL_JOB:
      return {
        ...state,
        rentOrderEmailJobQueue: [
          ...state.rentOrderEmailJobQueue,
          {
            ...action.data,
          },
        ],
      };

    case DEQUEUE_RENT_ORDER_EMAIL_JOB:
      return {
        ...state,
        rentOrderEmailJobQueue: state.rentOrderEmailJobQueue.slice(1),
      };

    case SET_RENT_ORDER_EMAIL_JOB:
      return {
        ...state,
        rentOrderEmailJob: {
          ...state.rentOrderEmailJob,
          ...action.data,
        },
      };

    case RESET_RENT_ORDER_EMAIL_JOB:
      return {
        ...state,
        rentOrderEmailJob: { ...rentOrderEmailJobInitialState },
      };

    case "FETCH_PO_ORDER_CODE":
      return {
        ...state,
        fetchPoOrderCode: action.data,
      };
    case "FETCH_WAREHOUSE_PURCHASING_ORDER":
      return {
        ...state,
        fetchWarehousePurchasingOrder: action.data,
      };
    case "FETCH_PURCHASING_ORDER":
      return {
        ...state,
        fetchPurchasingOrder: action.data,
      };
    case "ADD_TO_WAREHOUSE":
      return {
        ...state,
        addToWarehouse: action.data,
      };
    case "UPDATE_ORDER_PRODUCT_QTY":
      return {
        ...state,
        updateOrderProductQty: action.data,
      };
    case "ADD_ITEM_IN_EXISTING_ORDER":
      return {
        ...state,
        addItemInExistingOrder: action.data,
      };

    case "FETCH_SUPPLIERS":
      return {
        ...state,
        fetchSuppliers: action.data,
        fetchsupplierlist: action.data,
      };
    case "FETCH_PRODUCT":
      return {
        ...state,
        fetchProductList: action.data,
      };
    case "FETCH_PRODUCTION_HISTORY":
      return {
        ...state,
        fetchProductionHistory: action.data,
      };
    case "DELETE_PRODUCT":
      return {
        ...state,
        deleteProductList: action.data,
      };
    case "FETCH_SUPPLIERS_PRODUCT":
      return {
        ...state,
        fetchSuppliersProduct: action.data,
      };
    case "FETCH_LAST_PURCHASING_ORDER_CODE_ASSET_LIST":
      return {
        ...state,
        fetchLastPurchasingOrderCode: action.data,
      };
    case "FETCH_ASSET_EQUIPMENT_LIST":
      return {
        ...state,
        fetchEquipmentAndPart: action.data,
      };
    case "FETCH_PRODUCT_PART":
      return {
        ...state,
        fetchProductPart: action.data,
      };
    case "EMPTY_PRODUCT_PART":
      return {
        ...state,
        fetchProductPart: action.data,
        recentColors: action.data,
        addProductPart: action.data,
        updateProductPart: action.data,
        fetchDocumentByProductPartId: action.data,
        fetchTaskResponse: action.data,
        fetchContactTaskResponse: action.data,
        addTaskResponse: action.data,
        FetchContactByIddata: action.data,
      };
    case "ADD_PRODUCT_PART":
      return {
        ...state,
        addProductPart: action.data,
      };
    case "PRODUCT_PART_CODE_EMAIL_EXIST_OR_NOT":
      return {
        ...state,
        productPartCodeEmailExistOrNot: action.data,
      };
    case "ADD_COLOR_CODE":
      return {
        ...state,
        selectedColor: action.data,
        recentColors: [...state.recentColors, action.data],
      };
    case "DELETE_COLOR":
      const updatedColors = [...state.recentColors];
      updatedColors.splice(action.payload, 1);
      return {
        ...state,
        recentColors: updatedColors,
      };
    case "ADD_STOCK_COLOR_CODE":
      return {
        ...state,
        selectedStockColor: action.data,
        recentStockColors: [...state.recentStockColors, action.data],
      };
    case "DELETE_STOCK_COLOR":
      const updatedStockColors = [...state.recentStockColors];
      updatedStockColors.splice(action.payload, 1);
      return {
        ...state,
        recentStockColors: updatedStockColors,
      };
    case "SET_APP_SIDENAV_OPTIONS":
      return {
        ...state,
        appSideNavOptions: action?.data || [],
      };
    case "UPDATE_PRODUCT_PART":
      return {
        ...state,
        updateProductPart: action.data,
      };

    case "TOTAL_STOCK_AVAILABLE":
      return {
        ...state,
        totalStockAvailable: action.data,
      };

    case "ADVICED_ITEM_PURCHASE":
      return {
        ...state,
        advicedItemPurchase: action.data,
      };

    case "JIT_ADVICED_ITEM_PURCHASE":
      return {
        ...state,
        JITAdvicedItemPurchase: action.data,
      };

    case "ADVICED_PURCHASE_ORDER_LIST":
      return {
        ...state,
        advicedPurchaseOrderList: action.data,
      };

    case "JIT_PURCHASE_ORDER_LIST":
      return {
        ...state,
        JITPurchaseOrderList: action.data,
      };

    case "FETCH_PURCHASING_ORDER_AWAITING":
      return {
        ...state,
        fetchPurchasingOrderAwaiting: action.data,
      };
    case "FETCH_PAYROLLHISTORY":
      return {
        ...state,
        fetchPayrollHistory: action.data,
      };
    case "FETCH_NOT_ENROLLED_PAYROLL":
      return {
        ...state,
        fetchNotEnrolledPayroll: action.data,
      };
    case "FETCH_DOCUMENT_BY_PRODUCT_PART_ID":
      return {
        ...state,
        fetchDocumentByProductPartId: action.data,
      };
    case "FETCH_DOCUMENT_BY_ASSETS_ID":
      return {
        ...state,
        fetchDocumentByAssetsId: action.data,
      };

    case "DELETE_PRODUCT_DOCUMENT":
      return {
        ...state,
        fetchDocumentByProductPartId: {
          ...state.fetchDocumentByProductPartId,
          data: state.fetchDocumentByProductPartId.data.filter(
            (items) => items.documentid !== action.data.data,
          ),
        },
      };
    case "DELETE_ASSETS_DOCUMENT":
      return {
        ...state,
        fetchDocumentByAssetsId: {
          ...state.fetchDocumentByAssetsId,
          data: state.fetchDocumentByAssetsId.data.filter(
            (items) => items.documentid !== action.data.data,
          ),
        },
      };

    case "FETCH_PROJECTS_DROPDOWN":
      return {
        ...state,
        fetchProjectDropdown: action.data,
      };

    case "FETCH_PROJECT_CLIENT":
      return {
        ...state,
        fetchProjectClientRes: action.data,
      };

    case "FETCH_PRODUCT_DROPDOWN":
      return {
        ...state,
        fetchProductDropdown: action.data,
      };
    case "FETCH_ORDER_PICKING_PRODUCT":
      return {
        ...state,
        fetchOrderPickingProductDropdown: action.data,
      };
    case "ADD_RETURN_TO_WAREHOUSE":
      return {
        ...state,
        addReturnToWarehouseRes: action.data,
      };
    case "UPDATE_PRODUCT_DROPDOWN":
      const updatedData = state.fetchProductDropdown.data.map((product) => {
        const updatedSuppliers = product.supplier?.map((supplier) => {
          if (
            supplier.productPartSupplierid ===
            action.payload.productPartSupplierid
          ) {
            return {
              ...supplier,
              instock: action.payload.stock,
            };
          }
          return supplier;
        });
        return {
          ...product,
          suppliers: updatedSuppliers,
        };
      });
      return {
        ...state,
        fetchProductDropdown: {
          ...state.fetchProductDropdown,
          data: updatedData,
        },
      };
    case "CREATE_ORDER_PICKING":
      return {
        ...state,
        createOrderPicking: action.data,
      };
    case "UPDATE_PRODUCT_PART_STOCK":
      return {
        ...state,
        updateProductPartStock: action.data,
      };

    case "UPDATE_COUNT_STOCK":
      if (state.fetchProductDropdown.data) {
        setTimeout(() => {
          let i = state.fetchProductDropdown.data.findIndex(
            (p) => p.productPartid === action.data.data[0].productPartId,
          );
          state.fetchProductDropdown.data[i].instock =
            action.data.data[0].qtyCount;
        }, 1000);
      }
      return {
        ...state,
        updateCountStock: action.data,
      };

    case "UPDATE_CHECK_COUNT_STOCK":
      return {
        ...state,
        updateCheckCountStock: action.data,
      };
    case "DELETE_PRODUCT_PART_STOCK":
      const { updateProductPartStock: garbage, ...State } = state;
      return State;
    case "ADD_COMPANY_DETAILS":
      return {
        ...state,
        addCompanyDetails: action.data,
      };
    case "GET_USER_TIME_SESSION":
      return {
        ...state,
        userTimeSession: action.data,
      };
    case "FETCH_PO_BY_PROJECT":
      return {
        ...state,
        fetchPOByProjectResponse: action.data,
      };
    case "FETCH_QUOTES":
      return {
        ...state,
        fetchQuotesResponse: action.data,
      };
    case "FETCH_INVOICES":
      return {
        ...state,
        fetchInvoicesResponse: action.data,
      };
    case "ADD_INVOICES":
      return {
        ...state,
        addInvoicesResponse: action.data,
      };

    case "FETCH_LAST_QUOTE_CODE":
      return {
        ...state,
        FetchlastQuotecodeResponse: action.data,
      };
    case "CREATE_DUPLICATE_QUOTES":
      return {
        ...state,
        CreateDuplicateQuotesResponse: action.data,
      };
    case "DEACTIVATED_QUOTE":
      return {
        ...state,
        DeativatedQuoteResponse: action.data,
      };
    case "CHECK_IF_TIME_SESSION":
      return {
        ...state,
        CheckIfTimeSessionStartOrNotResponse: action.data,
      };
    case "CREATE_NEW_TIME_SESSION":
      return {
        ...state,
        CreateNewTimeSessionResponse: action.data,
      };
    case "GET_TIME_SESSION":
      return {
        ...state,
        GetTimeSessionResponse: action.data,
      };
    case "UPDATE_TIME_SESSION":
      return {
        ...state,
        UpdateTimeSessionResponse: action.data,
      };
    case "GET_ACTIVE_TIME_SESSION":
      return {
        ...state,
        GetActiveTimeSessionOnPlanboardResponse: action.data,
      };
    case "STOP_TIMER_FROM_HEADER":
      return {
        ...state,
        StopTimerFromHeaderResponse: action.data,
      };
    case "OPEN_TIMER_FROM_HEADER":
      return {
        ...state,
        OpenTimerFromHeaderResponse: action.data,
      };

    case "DELETE_TASK_ID_FROM_TIMER":
      return {
        ...state,
        StopTimerFromHeaderResponse: {},
        OpenTimerFromHeaderResponse: {},
      };

    // ASC REDUX PROPS START //
    case "BOOKKEEPING_PROPS":
      return {
        ...state,
        bookkeeping_props: action.data,
      };
    // ASC REDUX PROPS END //

    case "SET_STATUS_FALSE":
      const { AddJobtypes } = state;
      return {
        ...state,
        AddJobtypes: { ...AddJobtypes, status: false },
      };

    case "FETCH_ADD_PROJECT_ID":
      return {
        ...state,
        fetchAddProjectId: action.data,
      };

    case "CHANGE_PROJECT_TAB":
      return {
        ...state,
        projectTab: action.data,
      };

    case "SET_STATUS_TO_FALSE":
      return {
        ...state,
        addPurchasingOrder: { status: false },
      };

    case "FETCH_INVOICE_BY_ID":
      return {
        ...state,
        fetchInvoiceByIdResponse: action.data,
      };
    case "DELETE_PO_ASSET":
      return {
        ...state,
        deletePo: action.data,
      };
    case "CHANGE_PO_STATUS":
      return {
        ...state,
        changePoStatus: action.data,
      };

    case "UPDATE_INVOICE":
      return {
        ...state,
        updateInvoiceResponse: action.data,
      };

    case "SET_INVOICE_STATUS_TO_FALSE":
      return {
        ...state,
        fetchInvoiceByIdResponse: { status: false },
      };

    case "ADD_UPDATE_FINANCIAL_BY_PROJECT":
      return {
        ...state,
        addUpdateFinancialByProjectResponse: action.data,
      };

    case "FETCH_FINANCIAL_BY_PROJECT":
      return {
        ...state,
        FetchFinancialByProjectResponse: action.data,
      };

    case "UPDATE_PROJECT_COVER":
      return {
        ...state,
        updateProjectCover: action.data,
      };
    case "FETCH_PROJECT_KAN_BAN":
      return {
        ...state,
        fetchProjectKanBan: action.data,
      };
    case "PROJECT_GROUPING":
      return {
        ...state,
        projectGrouping: action.data,
      };
    case "FETCH_PROJECT_WEEKLY":
      return {
        ...state,
        fetchProjectWeekly: action.data,
      };
    case "FETCH_QUOTES_BY_COMPANY_ID":
      return {
        ...state,
        FetchQuotesByCompanyidResponse: action.data,
      };
    case "ADD_QUOTES":
      return {
        ...state,
        AddQuotesResponse: action.data,
      };
    case "APPROVE_QUOTES":
      return {
        ...state,
        ApproveQuotesResponse: action.data,
      };
    case "ADD_SECTION":
      return {
        ...state,
        addSectionResponse: action.data,
      };
    case "GET_QUOTE_SECTIONS":
      return {
        ...state,
        getQuoteSectionsResponse: action.data,
      };
    case "DUPLICATE_SECTION":
      return {
        ...state,
        duplicateSectionResponse: action.data,
      };
    case "DELETE_SECTION":
      return {
        ...state,
        deleteSectionResponse: action.data,
      };
    case "UDPATE_QUOTE_SECTIONS":
      return {
        ...state,
        updateQuoteSectionsResponse: action.data,
      };
    case "DELETE_UPDATE_QUOTE_STATE":
      return {
        ...state,
        updateQuoteSectionsResponse: { state: false, data: null },
        getQuoteSectionsResponse: { state: false, data: null },
        AddQuotesResponse: { state: false, data: null },
        deleteSectionResponse: { state: false, data: null },
      };
    case "ADD_SUBSECTION":
      return {
        ...state,
        addSubSectionResponse: action.data,
      };
    case "DELETE_SUBSECTION":
      return {
        ...state,
        deleteSubSectionResponse: action.data,
      };
    case "SET_TIME_SESSION_TO_FALSE":
      return {
        ...state,
        CheckIfTimeSessionStartOrNotResponse: {},
      };
    case "ACTIVATE_QUOTE":
      return {
        ...state,
        activateQuoteResponse: action.data,
      };
    case "SET_EQUIPMENTS_DETAIL":
      return {
        ...state,
        equipments: action.data,
      };
    case "FETCH_TEAM_PROJECTWISE":
      return {
        ...state,
        FetchTeamProjectWiseResponse: action.data,
      };
    case "FETCH_TEAMS":
      return {
        ...state,
        FetchTeamsResponse: action.data,
      };
    case "UPDATE_PO_TASK_STATUS":
      return {
        ...state,
        UpdatePOTaskStatusResponse: action.data,
      };
    case "ADD_TASK_TO_TEAM":
      return {
        ...state,
        AddTaskToTeamResponse: action.data,
      };
    case "GET_PO_LIST":
      return {
        ...state,
        PoList: action.data,
      };
    case "APPROVE_PO":
      return {
        ...state,
        approvePO: action.data,
      };

    case "FETCH_INVOICE_ALL_LIST":
      return {
        ...state,
        fetchInvoioceAllList: action.data,
      };

    case "FETCH_PRODUCT_PART_LIST":
      return {
        ...state,
        fetchProductPartList: action.data,
      };

    case "ADD_INVOICE_PROJECT":
      return {
        ...state,
        addInvoiceProject: action.data,
      };

    case "UPDATE_INVOICE_PROJECT":
      return {
        ...state,
        updateInvoiceProjectRes: action.data,
      };

    case "FETCH_PAYMENT_DEADLINE":
      return {
        ...state,
        fetchPaymentDeadline: action.data,
      };

    case "FETCH_INVOICE_BY_INVOICE_ID":
      return {
        ...state,
        fetchInvoiceByInvoiceID: action.data,
      };

    case "FETCH_PROJECT_BY_CLIENT":
      return {
        ...state,
        fetchProjectByClientRes: action.data,
      };

    case "FETCH_PRODUCTS_BY_QUOTES":
      return {
        ...state,
        fetchProductsByQuotesRes: action.data,
      };

    case "INVOICE_DELETE":
      return {
        ...state,
        invoiceDeleteRes: action.data,
      };

    case "FETCH_INVOICE_SETTING_LIST":
      return {
        ...state,
        FetchInvoiceSettingListResponse: action.data,
      };
    case "FETCH_INVOICE_SETTING_BY_ID":
      return {
        ...state,
        fetchInvoiceSettingById: action.data,
      };
    case "ADD_INVOICE_SETTING":
      return {
        ...state,
        addInvoiceSetting: action.data,
      };

    case "FETCH_LAST_INVOICE_CODE":
      return {
        ...state,
        fetchLastInvoiceCodeRes: action.data,
      };

    case "FETCH_MEMBERS":
      return {
        ...state,
        fetchMembers: action.data,
      };

    case "FETCH_TEAM_MEMBERS":
      return {
        ...state,
        fetchTeamMembers: action.data,
        teamid: action.data.teamid,
      };

    case "ADD_TEAM":
      return {
        ...state,
        addTeamList: action.data,
      };

    case "DELETE_TEAM":
      return {
        ...state,
        deleteTeam: action.data,
      };

    case "FETCH_TEAM":
      return {
        ...state,
        fetchTeam: action.data,
      };

    case "UPDATE_TEAM":
      return {
        ...state,
        updateTeam: action.data,
      };

    case "DELETE_TEAM_MEMBER":
      return {
        ...state,
        deleteTeamMember: action.data,
      };
    case "FETCH_PARTS_LIST":
      return {
        ...state,
        fetchPartsList: action.data,
      };

    case "FETCH_ORDER_PICKING_LIST":
      return {
        ...state,
        fetchOrderPickingListRes: action.data,
      };
    case "FETCH_STOCK_ITEM_LIST":
      return {
        ...state,
        fetchStockListRes: action.data,
      };
    case "ADD_TO_COUNT_STOCK":
      return {
        ...state,
        addCountStockRes: action.data,
      };
    case "FETCH_COUNT_STOCK_REPORT":
      return {
        ...state,
        fetchCountStockReportRes: action.data,
      };
    case "DELETE_COUNT_STOCK":
      return {
        ...state,
        deleteCountStockReportRes: action.data,
      };

    case "ADD_ORDER_PICKING":
      return {
        ...state,
        addOrderPickingRes: action.data,
      };

    case "QUOTE_EXTRAWORK_VALIDATION":
      return {
        ...state,
        quoteExtraWorkValidation: action.data,
      };

    case "FETCH_EQUIPMENT_BY_WEEK":
      return {
        ...state,
        fetchEquipmentByWeekRes: action.data,
      };

    case "ADD_EQUIPMENT_TO_TASK":
      return {
        ...state,
        addEquipmentToTaskRes: action.data,
      };

    case "FETCH_PROVISIONAL":
      return {
        ...state,
        fetchProvisionalRes: action.data,
      };
    case ADD_CREDIT_NOTE:
      return {
        ...state,
        addCreditNote: action.data,
      };

    case "FETCH_ASSET_LIST":
      return {
        ...state,
        assetList: action.data,
      };

    case "ASSET_TYPES":
      return {
        ...state,
        assetTypes: action.data.data,
      };

    case "DELETE_ASSET":
      return {
        ...state,
        deleteAsset: action.data,
      };
    case "FETCH_PARTICULAR_ASSET":
      return {
        ...state,
        fetchParticularAsset: action.data,
      };

    case "FETCH_GROUP_LIST":
      return {
        ...state,
        groupList: action.data.data,
      };
    case "FETCH_PURCHASING_ASSET_LIST":
      return {
        ...state,
        fetchPurchasingAssetList: action.data,
      };
    case "FETCH_EQUIPMENTPARTLIST":
      return {
        ...state,
        equipemtPartList: action.data.data,
      };
    case "ADD_SELECTED_PART":
      return {
        ...state,
        selectedParts: [...state.selectedParts, action.payload],
      };
    case "REMOVE_SELECTED_PART":
      return {
        ...state,
        selectedParts: state.selectedParts.filter(
          (part) => part.partId !== action.payload,
        ),
      };
    case "UPDATE_SELECTED_PART":
      let partIndex = state.selectedParts.findIndex(
        (x) => x.partId == action.payload.partId,
      );
      let updatedSelectedParts = state.selectedParts;
      updatedSelectedParts[partIndex] = action.payload;
      return {
        ...state,
        selectedParts: [...updatedSelectedParts],
      };
    case "SET_SELECTED_PART":
      return {
        ...state,
        selectedParts: [...action.payload],
      };
    case "DELETE_GROUP":
      return {
        ...state,
        deleteGroup: action.data,
      };
    case "ADD_GROUP_SUCCESS":
      // Handle success state or update state accordingly
      return {
        ...state,
        // Update state with the new group data if needed
      };
    case "ADD_GROUP_FAILURE":
      // Handle failure state or errors accordingly
      return {
        ...state,
        // Update state with error information if needed
      };
    case "FETCH_CLIENT_LIST":
      return {
        ...state,
        clientList: action.data.data,
      };
    case "FETCH_EQUIPMENT_LIST":
      return {
        ...state,
        equipmentList: action.data.data,
      };
    case "FETCH_CATEGORY_LIST":
      return {
        ...state,
        categoryList: action.data.data,
      };
    case "FETCH_FACILITY_LIST":
      return {
        ...state,
        facilityList: action.data.data,
      };
    case "ADD_ASSETS_EQUIPMENT":
      return {
        ...state,
        assetsListNew: action.payload,
      };
    case "FETCH_ASSETS_TYPE_LIST":
      return {
        ...state,
        assetsTypeList: action.data.data,
      };
    case "UPDATE_SUPPLIER_CONTACT_POSITION":
      return {
        ...state,
        updateSupplierContactPosition: action.data,
      };

    case "ADD_ASSETS":
      return {
        ...state,
        addAssets: action.data,
      };

    case UPDATE_ASSETS:
      // let index = state?.assetList?.findIndex(
      //   (a) => a.assetId === action?.data?.assetId
      // );
      // state.assetList[index] = { ...state?.assetList[index], ...action.data };
      return {
        ...state,
        assetUpdateRes: action.data,
      };
    case "IS_ACTIVE_WIDGET":
      return {
        ...state,
        dashboardWidgets: action.data,
      };

    case "ACTIVE_WORKER":
      return {
        ...state,
        showWorkersActivity: action.data,
      };
    case "TOP_PROJECT":
      return {
        ...state,
        showTopProjects: action.data,
      };
    case FETCH_TODAYONBOARDDETAILS:
      return {
        ...state,
        onboardDetails: action.data,
      };
    case "FETCH_TEAMS_LIST":
      return {
        ...state,
        fetchTeamsListResponse: action.data,
      };
    case "FETCH_EQUIPMENT_TASK_LIST":
      return {
        ...state,
        fetchEquipmentListResponse: action.data,
      };
    case "FETCH_ACTIVE_USER_LIST":
      return {
        ...state,
        fetchAssigneeResponse: action.data,
      };
    case "FETCH_INVENTORY":
      return {
        ...state,
        fetch365Inventory: [action.data],
      };
    case "WEEK_PROJECTS":
      return {
        ...state,
        projectsByWeek: action.data,
      };
    case "PROJECT_COUNT":
      return {
        ...state,
        weeklyProjectCount: action.data,
      };
    case "FETCH_INSTRUCTIONS_LIST":
      return {
        ...state,
        assetsInstructionsList: action.data,
      };

    case "TURN_UNAVAILABLE":
      return {
        ...state,
        turnUnacailableRes: action.data,
      };

    case "PRODUCT_AND_PART_VALIDATION":
      return {
        ...state,
        productAndPartValidationRes: action.data,
      };

    case LAST_365_INVOICE_INSIGHTS:
      return {
        ...state,
        last365InvoiceInsights: action.data,
      };

    case "MODAL_LIST":
      return {
        ...state,
        modalRes: action.data,
      };

    case "GLOBAL_REQUEST":
      const {
        data: { response, state2 },
      } = action;
      state[state2] = response;
      return {
        ...state,
      };

    case "INVOICE_SEND_EMAIL":
      return {
        ...state,
        invoiceSendEmailRes: action.data,
      };

    case "INVOICE_SEND_EMAIL_COUNT":
      return {
        ...state,
        invoiceSendEmailCountRes: action.data,
      };

    case "FETCH_LAST_CREDIT_INVOICE_CODE":
      return {
        ...state,
        fetchLastCreditInvoiceCodeRes: action.data,
      };

    case "INVOICE_GENRATE_PDF":
      return {
        ...state,
        invoiceGenratePDFRes: action.data,
      };

    case "FETCH_TASK_WITHOUT_PROJECT":
      return {
        ...state,
        fetchTaskWithoutProjectRes: action.data,
      };

    case "UPDATE_WAREHOUSE_ORDER_PROJECT":
      return {
        ...state,
        updateWareHouseProjectRes: action.data,
      };

    case "FETCH_PRODUCT_PART_CATEGORIES":
      return {
        ...state,
        fetchProductPartCategoriesRes: action.data,
      };

    case "FETCH_ASSET_PURCHASING_ORDER_BY_ID":
      return {
        ...state,
        fetchAssetPurchasingOrderByIdRes: action.data,
      };

    case "FETCH_PRODUCT_STOCK_FILTER_LIST":
      return {
        ...state,
        fetchProductFilterListRes: action.data,
      };

    case "SEND_INVOICE_EMAIL":
      return {
        ...state,
        sendInvoiceEmailRes: action.data,
      };

    case "SEND_INVOICE_EMAIL_COUNT":
      return {
        ...state,
        sendInvoiceEmailCountRes: action.data,
      };
    case "UPDATE_FILE_UPLOADING":
      return {
        ...state,
        isFileUploading: action.data,
      };

    case "USER_VERIFICATION":
      return {
        ...state,
        userVerificationRes: action.data,
      };

    case UPDATE_SYNC_QB_STATUS:
      return {
        ...state,
        qbSyncStatus: action.data,
        qbSyncResponse: action.response,
      };
    case PROJECT_COST_DETAILS:
      return {
        ...state,
        projectCostDetails: action.data,
      };

    case "TASK_MODAL_COMMENT_DELETE":
      return {
        ...state,
        taskModalCommentDeleteRes: action.data,
      };

    case "ADD_BILLING_INFORMATION":
      return {
        ...state,
        addBillingInformationRes: action.data,
      };

    case "UPDATE_BILLING_INFORMATION":
      return {
        ...state,
        updateBillingInformationRes: action.data,
      };

    case "FETCH_BILLING_INFORMATION":
      return {
        ...state,
        fetchBillingInformationRes: action.data,
      };

    case "FETCH_INDUSTRY":
      return {
        ...state,
        fetchIndustryRes: action.data,
      };

    case "ADD_INDUSTRY_TO_COMPANY":
      return {
        ...state,
        addIndustryToCompanyRes: action.data,
      };

    case "SEND_APPROVED_QUOTES_EMAIL":
      return {
        ...state,
        sendApprovedQuotesEmailRes: action.data,
      };

    case OCR_PROCESSED_DOCUMENT:
      return {
        ...state,
        ocrProcessedDocument: action.data,
      };
    case OCR_DOCUMENT_SAVED:
      return {
        ...state,
        ocrDocumentSaved: action.data,
      };
    case OCR_FETCH_ALL_DOCUMENTS:
      return {
        ...state,
        ocrAllDocuments: action.data,
      };
    case OCR_DOCUMENT_ACCEPT:
      return {
        ...state,
        ocrDocumentAccept: action.data,
      };
    case OCR_DOCUMENT_DUPLICATE:
      return {
        ...state,
        ocrDocumentDuplicate: action.data,
      };
    case OCR_DOCUMENT_DELETE:
      return {
        ...state,
        ocrDocumentDelete: action.data,
      };
    case OCR_DOCUMENT_BY_ID:
      return {
        ...state,
        ocrDocumentById: action.data,
      };
    case "PO_SUPPLIER_PROPS_API":
      return {
        ...state,
        poSupplierNameIDRes: action.data,
      };

    case "ADD_FORM":
      return {
        ...state,
        addFormRes: action.data,
      };

    case "ADD_FORM_SECTION":
      return {
        ...state,
        addFormSectionRes: action.data,
      };

    case "FETCH_CLIENTS_BY_COMPANY":
      return {
        ...state,
        fetchClientsByCompanyRes: action.data,
      };

    case "ADD_PERSONAL_TASK":
      return {
        ...state,
        addPersonalTaskRes: action.data,
      };

    case "FETCH_PERSONAL_TASK":
      return {
        ...state,
        fetchPersonalTaskRes: action.data,
      };

    case "FETCH_INTERGRATION":
      return {
        ...state,
        fetchIntergrationRes: action.data,
      };

    case "UPDATE_ISCHECK_PERSONAL_TASK":
      return {
        ...state,
        updateIsCheckPersonalTaskRes: action.data,
      };

    case "AZURE_AUTH_TOKEN":
      return {
        ...state,
        azureTokenUpdateRes: action.data,
      };

    case "TEMPLATE_TYPES":
      return {
        ...state,
        templateTypes: action.data,
      };

    case "TEMPLATE_BUILDER_AVAILABLE_FIELDS":
      return {
        ...state,
        availableFields: action.data,
      };

    case "AVAILABLE_TEMPLATES":
      return {
        ...state,
        availableTemplates: action.data,
      };

    case "ADD_PERSONAL_TASK":
      return {
        ...state,
        addPersonalTaskRes: action.data,
      };

    case "FETCH_PERSONAL_TASK":
      return {
        ...state,
        fetchPersonalTaskRes: action.data,
      };

    case "FETCH_INTERGRATION":
      return {
        ...state,
        fetchIntergrationRes: action.data,
      };

    case "UPDATE_ISCHECK_PERSONAL_TASK":
      return {
        ...state,
        updateIsCheckPersonalTaskRes: action.data,
      };

    case "AZURE_AUTH_TOKEN":
      return {
        ...state,
        azureTokenUpdateRes: action.data,
      };

    case "TEMPLATE_TYPES":
      return {
        ...state,
        templateTypes: action.data,
      };

    case "TEMPLATE_BUILDER_AVAILABLE_FIELDS":
      return {
        ...state,
        availableFields: action.data,
      };

    case "AVAILABLE_TEMPLATES":
      return {
        ...state,
        availableTemplates: action.data,
      };

    case "FETCH_FORM_LIST":
      return {
        ...state,
        formList: action.data,
      };

    case "FETCH_WORKFLOW_FORM_LIST":
      return {
        ...state,
        workflowFormList: action.data,
      };

    case "FETCH_FORM_BY_ID":
      return {
        ...state,
        formById: action.data,
      };

    case "FETCH_TEMPLATE_FORMS":
      return {
        ...state,
        templateForms: action.data,
      };

    case "DELETE_FORM":
      return {
        ...state,
        deleteForm: action.data,
      };
    case "UPDATE_FORM":
      return {
        ...state,
        updateForm: action.data,
      };
    case "FETCH_FORM_BY_PROJECT":
      return {
        ...state,
        formsByProject: action.data,
      };

    case "LINK_FORM_BY_PROJECT":
      return {
        ...state,
        linkFormToProject: action.data,
      };
    case "UNLINK_FORM_BY_PROJECT":
      return {
        ...state,
        unlinkFormToProject: action.data,
      };
    case "LINK_TASK_BY_FORM":
      return {
        ...state,
        linkTaskToForm: action.data,
      };

    case "FETCH_ID_TYPE":
      return {
        ...state,
        idsType: action.data?.data,
      };

    case "FETCH_EMPLOYEETYPE":
      return {
        ...state,
        employeeType: action.data?.data,
      };

    case "FETCH_CONTRACT_TYPE":
      return {
        ...state,
        contractType: action.data?.data,
      };

    case "FETCH_COMPANY_CAR":
      return {
        ...state,
        companyCar: action.data?.data,
      };

    case "FETCH_REASONS":
      return {
        ...state,
        fetchedReasons: action.data?.data,
      };

    case "FETCH_USER_CERTIFICATION":
      return {
        ...state,
        fetchedCertification: action.data?.data,
      };

    case "INSERT_DOC_TO_S3":
      return {
        ...state,
        insertedDoc: action.data?.data,
      };

    case "WORKFLOW_LIST_BY_COMPANY":
      return {
        ...state,
        workflowList: action.data,
      };

    case "WORKFLOW_CONDITION_TRIGGER":
      return {
        ...state,
        workflowTriggerList: action.data,
      };

    case "WORKFLOW_CONDITION_RULES":
      return {
        ...state,
        workflowRulesList: action.data,
      };

    case "WORKFLOW_CONDITION_TASK_STATUS":
      return {
        ...state,
        workflowTaskStatusList: action.data,
      };

    case "WORKFLOW_CONDITION_TASK_LIST":
      return {
        ...state,
        workflowTaskList: action.data,
      };

    case "WORKFLOW_ACTIONS":
      return {
        ...state,
        workflowActions: action.data,
      };

    case "WORKFLOW_TASK_TYPE":
      return {
        ...state,
        workflowTaskType: action.data,
      };

    case "WORKFLOW_QUESTIONS":
      return {
        ...state,
        workflowQuestions: action.data,
      };

    case "FETCH_USER_MAX_AMOUNT":
      return {
        ...state,
        fetchUserMaxAmountRes: action.data,
      };

    case "UPDATE_USER_MAX_AMOUNT":
      return {
        ...state,
        updateUserMaxAmountRes: action.data,
      };

    case "APPROVED_ORDER":
      return {
        ...state,
        approvedOrderRes: action.data,
      };

    case "WORKFLOW_INFO":
      return {
        ...state,
        workflowData: action.data,
      };

    case "FETCH_PROJECT_BILLING_TERMS":
      return {
        ...state,
        fetchBillingTermsRes: action.data,
      };

    case "EMPTY_TASK_STATE":
      return {
        ...state,
        fetchTaskResponse: {},
      };

    case "ADD_NEW_CLIENT":
      return {
        ...state,
        addNewClientRes: action.data,
      };

    case "UPDATE_CLIENT_COMPANY":
      return {
        ...state,
        updateCompanyRes: action.data,
      };

    case "UPDATE_CLIENT_DETAILS":
      return {
        ...state,
        updateClientDetailsRes: action.data,
      };

    case "FETCH_CLIENT_BY_ID":
      return {
        ...state,
        fetchClientByIdRes: action.data,
      };

    case "EXISTING_COMPANY_ADDRESS":
      return {
        ...state,
        existingCompanyAddressRes: action.data,
      };

    case "DELETE_MULTIPLE_ADDRESS":
      return {
        ...state,
        deleteMultipleAdressRes: action.data,
      };

    case "FETCH_CLIENT_CONTACTS_BY_CLIENT_ID":
      return {
        ...state,
        fetchClientContactsByClientIdRes: action.data,
      };

    case "FETCH_CLIENT_TASKS":
      return {
        ...state,
        fetchClientTasksRes: action.data,
      };

    case "CLIENT_ACTIVITY_TIMELINE":
      return {
        ...state,
        clientActivityTimelineRes: action.data,
      };

    case "GET_CREDIT_TYPE_DROPDOWN":
      return {
        ...state,
        getCreditTypeDropDownRes: action.data,
      };

    case "GET_INVOICE_TYPE_DROPDOWN":
      return {
        ...state,
        getInvoiceTypeDropDownRes: action.data,
      };

    case "GET_DISCOUNT_TYPE_DROPDOWN":
      return {
        ...state,
        getDiscountTypeDropDownRes: action.data,
      };

    case "ADD_DISCOUNT":
      return {
        ...state,
        addDiscountRes: action.data,
      };

    case "DELETE_CLIENT_CONTACT":
      return {
        ...state,
        dleteClientContactRes: action.data,
      };

    case "QUOTE_PRODUCTS_STATE":
      return {
        ...state,
        quoteProducts: action.data,
      };

    case "SEND_EMAIL_REGISTRATION":
      return {
        ...state,
        emailRes: action.data,
      };

    case "EMPTY_ADD_QUOTES_STATE":
      return {
        ...state,
        AddQuotesResponse: {},
      };

    case "ADD_FORM_RESPONSE":
      return {
        ...state,
        formResponse: action.data,
      };

    case "QUOTE_GENRATE_PDF":
      return {
        ...state,
        quoteGenratePDFResponse: action.data,
      };

    case "FETCH_PROJECT_WORKS":
      return {
        ...state,
        fetchProjectWorksRes: action.data,
      };

    case "DELETE_WORK_LIST":
      return {
        ...state,
        deleteWorkListRes: action.data,
      };

    case "ADD_WORK_TASK":
      return {
        ...state,
        addWorkTaskRes: action.data,
      };

    case "DELETE_WORK_TASK":
      return {
        ...state,
        deletWorkTaskRes: action.data,
      };

    case "FETCH_WORK_TASK_BY_ID":
      return {
        ...state,
        fetchWorkTaskByIdRes: action.data,
      };

    case "UPDATE_WORK_TASK":
      return {
        ...state,
        updateWorkTaskRes: action.data,
      };

    case "PROJECT_HIRING_LIST":
      return {
        ...state,
        projectHireListRes: action.data,
      };

    case "PROJECT_HIRE_CREATE":
      return {
        ...state,
        projectHireCreateRes: action.data,
      };

    case "PROJECT_HIRE_UPDATE":
      return {
        ...state,
        projectHireUpdateRes: action.data,
      };

    case "PROJECT_HIRE_DELETE":
      return {
        ...state,
        projectHireDeleteRes: action.data,
      };

    case "UPDATE_PROJECT_HIRING_STATUS":
      return {
        ...state,
        UpdateProjectHiringStatusRes: action.data,
      };

    case "UPDATE_PROJECT_HIRING_EXTEND_PERIOD":
      return {
        ...state,
        UpdateProjectHiringExtendPeriodRes: action.data,
      };

    case "PROJECT_RENT_DELETE":
      return {
        ...state,
        projectRentDeleteRes: action.data,
      };

    case "UPDATE_PROJECT_RENT_STATUS":
      return {
        ...state,
        UpdateProjectRentStatusRes: action.data,
      };

    case "UPDATE_PROJECT_RENT_EXTEND_PERIOD":
      return {
        ...state,
        UpdateProjectRentExtendPeriodRes: action.data,
      };

    case "ADD_PHASE_MATERIALS":
      return {
        ...state,
        addPhaseMaterialsRes: action.data,
      };

    case "FETCH_PHASE_MATERIALS_BY_PROJECT":
      return {
        ...state,
        fetchPhaseMaterialsByProjectRes: action.data,
      };

    case "FETCH_PHASE_MATERIALS_BY_ID":
      return {
        ...state,
        fetchPhaseMaterialsByIdRes: action.data,
      };

    case "DELETE_PHASE":
      return {
        ...state,
        deletePhaseRes: action.data,
      };

    case "DELETE_MATERIALS":
      return {
        ...state,
        deleteMaterialsRes: action.data,
      };

    case "ADD_MATERIAL_LIST":
      return {
        ...state,
        addMaterialListRes: action.data,
      };

    case "FETCH_MATERIALS_LIST":
      return {
        ...state,
        fetchMaterialListRes: action.data,
      };

    case "UPDATE_MATERIALS_QUANTITY":
      return {
        ...state,
        updateMaterialQuantityRes: action.data,
      };

    case "UPDATE_TASK_IMAGE":
      return {
        ...state,
        updateTaskImageRes: action.data,
      };

    case "FETCH_USER_TITLE":
      return {
        ...state,
        fetchUserTitleRes: action.data,
      };

    case "ADD_UPDATE_USER_TITLE":
      return {
        ...state,
        addUpdateUserTitleRes: action.data,
      };

    case "DELETE_USER_TITLE":
      return {
        ...state,
        deleteUserTitleRes: action.data,
      };

    case "FETCH_PROJECTS_BY_WEEKS":
      return {
        ...state,
        fetchProjectsByWeeksRes: action.data,
      };

    case "EMPTY_PRODUCT_BY_SUPPLIER":
      return {
        ...state,
        fetchOrderPickingProductDropdown: {},
      };

    case "SINGLE_UPLOAD_TO_S3":
      return {
        ...state,
        singleUploadToS3Res: action.data,
      };

    case "MULTIPLE_UPLOAD_TO_S3":
      return {
        ...state,
        multipleUploadToS3Res: action.data,
      };

    case "DOWNLOAD_DOCUMENT":
      return {
        ...state,
        downloadDocumentRes: action.data,
      };

    case "STORE_TIMER_SCREEN_SHOTS":
      return {
        ...state,
        storeTimerScreenShotsRes: action.data,
      };

    case "TIME_MANAGEMENT_SESSION_TIMELINE":
      return {
        ...state,
        timeManagementSessionTimeLineRes: action.data,
      };

    case "DELETE_SCREENSHOTS":
      return {
        ...state,
        deleteScreenShotsRes: action.data,
      };

    case "TIME_MANAGEMENT_DAILY_SUMMARY":
      return {
        ...state,
        timeManagementDailySummaryRes: action.data,
      };

    case "ADD_TRANSLATION_DATA":
      return {
        ...state,
        addTranslationDataRes: action.data,
      };

    case "ADD_NEW_PROJECT_BILLING":
      return {
        ...state,
        addNewBillingRes: action.data,
      };

    case "DELETE_NEW_PROJECT_BILLING":
      return {
        ...state,
        deleteNewBillingRes: action.data,
      };

    case "DELETE_USER_TIME_OFF":
      return {
        ...state,
        deleteUserTimeOffRes: action.data,
      };

    case "FECTH_UNITS_PRODUCTS":
      return {
        ...state,
        fecthUnitsProductsRes: action.data,
      };

    case "UPDATE_DELETE_EMPLOYEE_TYPE":
      return {
        ...state,
        AddTypeOfEmployeeRes: action.data,
      };

    case "UPDATE_DELETE_ID_TYPE":
      return {
        ...state,
        AddTypeOfIDRes: action.data,
      };

    case "UPDATE_DELETE_CONTRACT_TYPE":
      return {
        ...state,
        AddContractTypeRes: action.data,
      };

    case "UPDATE_DELETE_COMPANY_CAR":
      return {
        ...state,
        AddBenifitCompanyCarRes: action.data,
      };

    case "UPDATE_DELETE_REASONS":
      return {
        ...state,
        AddBenifitReasonsRes: action.data,
      };

    case "MAKING_TEMPLATE_DEFAULT":
      return {
        ...state,
        makeTemplateDefaultRes: action.data,
      };

    case "FETCH_ISDEFAULT_TEMPLATE":
      return {
        ...state,
        fetchDefaultTemplateRes: action.data,
      };

    case "FILES_INSERT_DOC_TO_S3":
      return {
        ...state,
        filesInsertDocToS3Res: action.data,
      };

    case "ADD_DOCUMENT_TO_TASK":
      return {
        ...state,
        addDocumentToTaskRes: action.data,
      };

    case "ADD_TASK_FORM":
      return {
        ...state,
        addTaskFormRes: action.data,
      };

    case "UPDATE_TASK_FORM":
      return {
        ...state,
        updateTaskFormRes: action.data,
      };

    case "DELETE_TASK_FORM":
      return {
        ...state,
        deleteTaskFormRes: action.data,
      };

    case "FETCH_TASK_FORM":
      return {
        ...state,
        fetchTaskFormRes: action.data,
      };

    case "DELETE_BOM_ITEM":
      return {
        ...state,
        deleteBOMitemRes: action.data,
      };

    case "DELETE_SUB_SECTION_PARTS":
      return {
        ...state,
        deleteSubSectionPartsRes: action.data,
      };

    case "DRIVE_ADD_FOLDER":
      return {
        ...state,
        driveAddFolderRes: action.data,
      };

    case "FETCH_ZERO_PARENTS_FOLDER":
      return {
        ...state,
        zeroParentsFolderRes: action.data,
      };

    case "FETCH_SPIRE_FOLDER_DOCUMENTS":
      return {
        ...state,
        fetchSpireFolderDocumentsRes: action.data,
      };

    case "DELETE_DRIVE_FOLDER_OR_FILE":
      return {
        ...state,
        deleteDriveFolderORFileRes: action.data,
      };

    case "ADD_DOC_ROOT":
      return {
        ...state,
        addDocRootRes: action.data,
      };

    case "DRIVE_UPDATE_FOLDER":
      return {
        ...state,
        driveUpdateFolderRes: action.data,
      };

    case "FILE_CHUNK_START":
      return {
        ...state,
        fileChunkStartRes: action.data,
      };

    case "FILE_PRESIGN":
      return {
        ...state,
        filePresignRes: action.data,
      };

    case "FILE_CHUNK_COMPLETE":
      return {
        ...state,
        fileChunkCompleteRes: action.data,
      };

    case "FILE_CHUNK_ABORT":
      return {
        ...state,
        fileChunkAbortRes: action.data,
      };

    case "FETCH_FORM_CERTIFICATES":
      return {
        ...state,
        fetchFormCertificateRes: action.data,
      };

    case "AJIT_SPIRE_API_JSON":
      return {
        ...state,
        ajitSpireJsonApiRes: action.data,
      };

    case "COWORKER_CERTIFICATIONS_ADD_UPDTE_DELETE":
      return {
        ...state,
        coWorkerCertificationsApiRes: action.data,
      };

    case "FETCH_TODO_LIST":
      return {
        ...state,
        fetchToDoListApiRes: action.data,
      };

    case "UPDATE_TASK_PRIORITY":
      return {
        ...state,
        updateTaskPriorityApiRes: action.data,
      };

    case "UPDATE_TASK_ASSIGNEE":
      return {
        ...state,
        updateTaskAssigneeApiRes: action.data,
      };

    case "UPDATE_TASK_INDEX":
      return {
        ...state,
        updateTaskIndexApiRes: action.data,
      };

    case "UPDATE_CHECKLIST_DATA":
      return {
        ...state,
        updateChecklistDataRes: action.data,
      };

    case "DELETE_PROJECT":
      return {
        ...state,
        deleteProjectRes: action.data,
      };

    case "ADD_TASK_DESCRIPTION":
      return {
        ...state,
        addTaskDescriptionRes: action.data,
      };

    case "FETCH_BRAND_HEALTH_APPLICATION":
      return {
        ...state,
        fetchBrandHealthApplicationRes: action.data,
      };

    case "SUPPLIER_EMAIL_EXIST_OR_NOT":
      return {
        ...state,
        supplierEmailExistOrNotRes: action.data,
      };

    case "CLIENT_NAME_EXIST_OR_NOT":
      return {
        ...state,
        clientNameExistOrNotRes: action.data,
      };

    case "REMOVE_TASK_ASSIGNEE":
      return {
        ...state,
        removeTaskAssigneeRes: action.data,
      };

    case "SET_ASSIGNEE_LOCAL_DATA":
      return {
        ...state,
        assigneeLocalDataRes: action.data,
      };

    case "PRODUCT_CATALOGUE_API":
      return {
        ...state,
        productCatalogueApiRes: action.data,
      };

    case "FETCH_AUTO_PRODUCT_PART_ITEM_ID":
      return {
        ...state,
        fetchAutoProductPartItemIDRes: action.data,
      };

    case "DUPLICATE_TEMPLATE":
      return {
        ...state,
        duplicateTemplateRes: action.data,
      };

    case "FETCH_TODO_LIST_BY_PROJECT":
      return {
        ...state,
        fetchTodoListByProjectRes: action.data,
      };

    case "ADD_DOCUMENT_TO_ORDER":
      return {
        ...state,
        addDocumentToOrderRes: action.data,
      };

    case "FETCH_DOCUMENT_BY_ORDERID":
      return {
        ...state,
        fetchDocumentByOrderIDRes: action.data,
      };

    case "FETCH_PRODUCT_WITHOUT_SUPPLIER":
      return {
        ...state,
        fetchProductsWithoutSupplierRes: action.data,
      };

    case "ADD_SUPPLIER_TO_PRODUCT":
      return {
        ...state,
        addSupplierToProductsRes: action.data,
      };

    case "SUPPLIER_CODE_EXIST_OR_NOT":
      return {
        ...state,
        supplierCodeExistOrNotRes: action.data,
      };

    case "SUPPLIER_BAR_CODE":
      return {
        ...state,
        supplierBarCodeRes: action.data,
      };

    case "SUPPLIER_BAR_CODE_SCAN":
      return {
        ...state,
        supplierBarCodeScanRes: action.data,
      };

    case "SEND_PO_EMAIL_TO_SUPPLIER":
      return {
        ...state,
        sendEmailToSupplierRes: action.data,
      };

    case "PART_DUPLICATE":
      return {
        ...state,
        partDuplicateRes: action.data,
      };

    case "UPDATE_PRODUCT_DESCRIPTION":
      return {
        ...state,
        updateProductDescriptionRes: action.data,
      };

    case "ADD_TASK_ACTIVITY":
      return {
        ...state,
        addTaskActivityRes: action.data,
      };

    case "UPDATE_TASK_ACTIVITY":
      return {
        ...state,
        updateTaskActivityRes: action.data,
      };

    case "SEARCH_ACTIVITY":
      return {
        ...state,
        searchActivityRes: action.data,
      };

    case "FETCH_ACTIVITY":
      return {
        ...state,
        fetchActivityRes: action.data,
      };

    case "DELETE_ACTIVITY":
      return {
        ...state,
        deleteActivityRes: action.data,
      };

    case "TIMER_FOR_ACTIVITY":
      return {
        ...state,
        timerActivityRes: action.data,
      };

    case "GET_TIMER_FOR_ACTIVITY":
      return {
        ...state,
        getTimerActivityRes: action.data,
      };

    case "FETCH_PROJECT_EQUIPMENT_ACTIVITY":
      return {
        ...state,
        fetchProjectEquipmentActivityRes: action.data,
      };

    case "SEARCH_AI_FOLDER_FILE":
      return {
        ...state,
        searchAiFolderFileRes: action.data,
      };

    case "UPDATE_USER_FILTER":
      return {
        ...state,
        updateUserFilterRes: action.data,
      };

    case "ADD_PARTS_EQUIPMENTS":
      return {
        ...state,
        addPartsEquipmentsRes: action.data,
      };

    case "FETCH_PARTS_EQUIPMENTS":
      return {
        ...state,
        fetchPartsEquipmentsRes: action.data,
      };

    case "UPDATE_PARTS_EQUIPMENTS":
      return {
        ...state,
        updatePartsEquipmentsRes: action.data,
      };

    case "DELETE_PARTS_EQUIPMENTS":
      return {
        ...state,
        deletePartsEquipmentsRes: action.data,
      };

    case "UPDATE_TASK_ESTIMATIONS":
      return {
        ...state,
        updateTaskEstimationsRes: action.data,
      };

    case "BUILD_PO_DATA":
      return {
        ...state,
        buildPOdataRes: action.data,
      };

    case "DELETE_RESOURCE_PO":
      return {
        ...state,
        deleteResourcePoRes: action.data,
      };

    case "LOGOUT_SESSION":
      return {
        ...state,
        logoutSessionRes: action.data,
      };

    case "FETCH_TASK_HISTORY":
      return {
        ...state,
        fetchTaskHistoryRes: action.data,
      };

    case "FETCH_TASK_TIMESHEET":
      return {
        ...state,
        fetchTaskTimesheetRes: action.data,
      };

    case "ADD_UPDATE_TASK_DEPENDENCIES":
      return {
        ...state,
        addUpdateTaskDependenciesRes: action.data,
      };

    case "DELETE_DEPENDENCIES":
      return {
        ...state,
        deleteDependenciesRes: action.data,
      };

    case "ADD_TASK_PRODUCTS_PART":
      return {
        ...state,
        addTaskProductPartsRes: action.data,
      };

    case "UPDATE_TASK_PRODUCTS_PART":
      return {
        ...state,
        updateTaskProductPartsRes: action.data,
      };

    case "FETCH_TASK_PRODUCTS_PART":
      return {
        ...state,
        fetchTaskProductPartsRes: action.data,
      };

    case "DELETE_TASK_PRODUCTS_PART":
      return {
        ...state,
        deleteTaskProductPartsRes: action.data,
      };

    case "FETCH_TASK_COST_DETAILS":
      return {
        ...state,
        fetchTaskCostDetailsRes: action.data,
      };

    case "CREATE_TASK_INVOICE":
      return {
        ...state,
        createTaskInvoiceRes: action.data,
      };

    case "UPDATE_SECTION_DEFAULT":
      return {
        ...state,
        updateSectionDefaultRes: action.data,
      };

    case "DELETE_COMPOSE_PRODUCT":
      return {
        ...state,
        deleteComposeProductRes: action.data,
      };

    case "UPDATE_TASK_PRODUCT_PART_QTY":
      return {
        ...state,
        updatePoductPartQtyRes: action.data,
      };

    default:
      return { ...state };
  }
};

export default userReducer;
